// Functies die de bestelhoeveelheid van een product aanpassen.
// De bestelknop leest de hoeveelheid direct uit de input; het change-event is voor overige listeners.

// zoekt vanaf het element omhoog naar het dichtstbijzijnde element dat aan de selector voldoet
const findNearest = (element, selector) => {
  let found = null;
  let parent = element.parentElement;

  while (parent && !found) {
    found = parent.querySelector(selector);
    parent = parent.parentElement;
  }

  return found;
};

const setQuantity = (trigger, productId, value) => {
  const quantityElement = findNearest(trigger, `[name="quantity"][id="cart-${productId}"]`);

  if (!quantityElement || Number.isNaN(value)) {
    return false;
  }

  quantityElement.value = value;

  // select zonder optie voor deze waarde: niets aanpassen
  if (parseInt(quantityElement.value, 10) !== value) {
    return false;
  }

  quantityElement.dispatchEvent(new Event('change', { bubbles: true }));

  return true;
};

class PriceUpdate {
  constructor(options = {}) {
    this.config = {
      vpeSelector: '[data-module="PriceUpdate__Vpe"]',
      // de rij heeft al data-module="RealTimePriceStaffels_Staffel", daarom op klasse
      staffelSelector: '.c-table-pricestaffels__option',
      ...options
    };
  }

  init() {
    this.initVpe();
    this.initStaffel();
    this.initStaffelSync();
  }

  // Klik op de VPE-regel vult de VPE in als bestelhoeveelheid.
  initVpe() {
    document.addEventListener('click', e => {
      const trigger = e.target.closest(this.config.vpeSelector);

      if (!trigger) {
        return;
      }

      e.preventDefault();

      const { vpe, productId } = trigger.dataset;

      setQuantity(trigger, productId, parseInt(vpe, 10));
    });
  }

  // Klik op een staffelregel vult de staffel in als bestelhoeveelheid.
  // De actieve regel volgt via initStaffelSync.
  initStaffel() {
    document.addEventListener('click', e => {
      const trigger = e.target.closest(this.config.staffelSelector);

      if (!trigger) {
        return;
      }

      const { staffel } = trigger.dataset;
      const { productId } = trigger.closest('[data-product-id]').dataset;

      setQuantity(trigger, productId, parseInt(staffel, 10));
    });
  }

  // Bij een andere bestelhoeveelheid wordt de bijbehorende staffel actief:
  // de hoogste staffel die kleiner of gelijk is aan de hoeveelheid (13 -> 10).
  initStaffelSync() {
    const sync = quantityElement => {
      const productId = quantityElement.id.replace('cart-', '');
      const staffels = findNearest(
        quantityElement,
        `[data-module="RealTimePriceStaffels"][data-product-id="${productId}"]`
      );

      if (!staffels) {
        return;
      }

      const quantity = parseInt(quantityElement.value, 10);
      const rows = [...staffels.querySelectorAll(this.config.staffelSelector)];
      const matching = rows.filter(row => parseInt(row.dataset.staffel, 10) <= quantity);
      const active = matching.length ? matching[matching.length - 1] : rows[0];

      rows.forEach(row => {
        row.classList.toggle('is-active', row === active);
      });
    };

    // typen in de input en de besteleenheid-select
    ['input', 'change'].forEach(type => {
      document.addEventListener(type, e => {
        if (e.target.name === 'quantity') {
          sync(e.target);
        }
      });
    });

    // plus/min van de Incrementer zetten de waarde zonder event
    document.addEventListener('click', e => {
      const button = e.target.closest('[data-module="incrementer"] [data-type]');
      const quantityElement =
        button && button.closest('[data-module="incrementer"]').querySelector('[name="quantity"]');

      if (quantityElement) {
        sync(quantityElement);
      }
    });
  }
}

export default PriceUpdate;
